import type { UseQueryResult } from '@tanstack/react-query';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import type { PodaniPodaniInstanceSeznamDto } from '@gov-nx/api';
import type { ProcessControlCore } from '@gov-nx/core/hooks';
import type { FilterParam, FilterSortDirection } from '@gov-nx/core/types';
import type {
	MySubmissionsBadge,
	MySubmissionTabs,
	PageCode,
	TimePeriod,
} from '@gov-nx/module/page';
import type { SubmissionStatus } from './utils';

export interface MySubmissionsListControl extends ProcessControlCore {
	displayFilter: boolean;
}

interface MySubmission {
	id: number;
	name: string;
	status: SubmissionStatus;
	period?: TimePeriod;
}

export interface MySubmissionsListContext {
	code: PageCode;
	controls: MySubmissionsListControl;
	submissions: MySubmission[];
	setControls: (control: Partial<MySubmissionsListControl>) => void;
	query: UseQueryResult<PodaniPodaniInstanceSeznamDto>;
	numberOfSubmissions: number;
	onSubmit: () => void;
	resetFilter: () => void;
	filter: MySubmissionsListFilter;
	setPartialFilter: (filter: Partial<MySubmissionsListFilter>) => void;
	currentPage: number;
	formDefinition: FormDefinition<MySubmissionListFilterForm>;
	goToPage: (page: number) => void;
	filterParams: FilterParam[];
	tabs: MySubmissionsBadge[];
	mySubmissionSelectedTab: MySubmissionTabs;
	setMySubmissionSelectedTab: (selectTab: MySubmissionTabs) => void;
}

export interface MySubmissionListFilterForm {
	lhutaVyrizeni?: Date | null;
	vyrizeno?: Date | null;
	razeni?: MySubmissionListOrder;
	razeniSmer?: FilterSortDirection;
	hledat?: string;
}

export enum MySubmissionListOrder {
	datumOdeslani = 'datumOdeslani',
	datumVyrizeni = 'datumVyrizeni',
	lhutaVyrizeni = 'lhutaVyrizeni',
	'-datumOdeslani' = '-datumOdeslani',
	'-datumVyrizeni' = '-datumVyrizeni',
	'-lhutaVyrizeni' = '-lhutaVyrizeni',
}

export interface MySubmissionsListFilter extends MySubmissionListFilterForm {
	smazano: boolean;
	start: number;
	pocet: number;
}

export interface DataRequest {
	params: {
		datumVyrizeni?: string;
		lhutaVyrizeni?: string;
		vyrizeno?: string;
		razeni?: MySubmissionListOrder;
		start?: number;
		pocet?: number;
	};
}
